import { SimpleGrid } from '@backyard-ui/core';

import { type ModularContent } from '@/infra/services/modular-content/model';
import { GtmDataAttributesGenerator } from '@/infra/tracking/gtm-data-attributes';
import * as tracker from '@/infra/tracking/tracker';
import { ImageWithFallback } from '@/presenters/components/common/ImageWithFallback';
import { useRunOnce } from '@/presenters/hooks/use-run-once';
import { useGlobalStore } from '@/presenters/store/global';

export interface InformativeProps extends ModularContent.Informatives {}

function Informative(props: InformativeProps) {
  const { items, size, type, title: moduleTitle } = props;

  const region = useGlobalStore((state) => state.session.region);

  useRunOnce(() => {
    tracker.onBannerView({
      items,
      moduleType: type,
      region: region,
    });
  }, Boolean(items.length) && Boolean(region));

  return (
    <SimpleGrid columns={size} gapX="4">
      {items.map(({ id, image, elementType, informativeUrl }, index) => (
        <a href={informativeUrl} target="_blank" key={id}>
          <div
            data-testid="informative"
            {...GtmDataAttributesGenerator.banner({
              elementType,
              type,
              name: image.alt,
              index: index,
              listName: moduleTitle ?? '',
            })}
          >
            <ImageWithFallback
              fallbackSrc={image.fallbackSrc}
              src={image.prioritySrc ?? image.url}
              alt={image.alt}
              width={image.size.width}
              height={image.size.height}
              className="w-full"
            />
          </div>
        </a>
      ))}
    </SimpleGrid>
  );
}

export default Informative;
